import { BRAND } from "../../../constants/brand";
import { PHI_LOGO } from "../../../constants/phi-logo";
import { useLocation } from "react-router-dom";
import { Drawer, Image, Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import { MenuOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import ButtonComponent from "../../common/button";
import { HashLink } from "react-router-hash-link";
import AuthFooterComponent from "../../common/footer";
import { MAIN_APP_LINK } from "../../../constants";




const { Header } = Layout;



const MainLayout = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [visible, setVisible] = useState(false);

  
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const showDrawer = () => {
    console.log("showing drawer");
    setVisible(true);
  };

  const closeDrawer = () => {
    setVisible(false);
  };

  const location = useLocation();
const currentPath = location.pathname;
  return (
    <Layout className={styles.layout}>
      <Header className={styles.header}>
        <Link to="/">
          <div className={styles.logo}>
            <Image src={PHI_LOGO.horizontal.default} alt={BRAND.product} preview={false} />
          </div>
        </Link>

        {/* Show menu in Drawer only on mobile */}
        {isMobile ? (
          <>
            <ButtonComponent
              {...{
                text: <MenuOutlined />,
                onClick: showDrawer,
              }}
            />
            <Drawer
              title="Menu"
              placement="left"
              onClose={closeDrawer}
              visible={visible}
              className={styles.drawer}
            >
              <Menu mode="vertical" selectedKeys={[currentPath]}>
                <Menu.Item>
                  <Link to="/">Home</Link>
                </Menu.Item>
                <Menu.Item>
                  <Link to="/values">Values</Link>
                </Menu.Item>
                <Menu.Item>
                  <Link to="/origin">Origin</Link>
                </Menu.Item>
                <Menu.Item>
                  <Link to="/Blogs">Blogs</Link>
                </Menu.Item>
                <Menu.Item>
                  <Link to="/news">News</Link>
                </Menu.Item>
                <Menu.Item>
                  <Link to={BRAND.urls.support}>
                    Support
                  </Link>
                </Menu.Item>
                <Menu.Item>
                  <Link to={`${MAIN_APP_LINK}/login`}>
                    <ButtonComponent
                      {...{ type: "primary", text: "Sign In" }}
                    />
                  </Link>
                </Menu.Item>
              </Menu>
            </Drawer>
          </>
        ) : (
          <Menu
            mode="horizontal"
            className={styles.menu}
            selectedKeys={[currentPath]}
          >
            <Menu.Item key="/">
              <Link to="/">Home</Link>
            </Menu.Item>
            <Menu.Item key="/values">
              <Link to="/values">Values</Link>
            </Menu.Item>
            <Menu.Item key="/origin">
              <Link to="/origin">Origin</Link>
            </Menu.Item>
            <Menu.Item key="/blogs">
              <Link to="/blogs">Blogs</Link>
            </Menu.Item>
            <Menu.Item key="/news">
              <Link to="/news">News</Link>
            </Menu.Item>
            <Menu.Item>
              {" "}
              <Link to={BRAND.urls.support}>Support</Link>
            </Menu.Item>
            <Menu.Item>
              <Link to={`${MAIN_APP_LINK}/login`}>
                <ButtonComponent {...{ type: "primary", text: "Sign In" }} />
              </Link>
            </Menu.Item>
          </Menu>
        )}
      </Header>
      {children}

      <AuthFooterComponent />
    </Layout>
  );
};

export default MainLayout;
